import { handleActions } from 'redux-actions'
import generateHandlerArgs from 'modules/reducerGenerator'
import { adminRecoAccountAction as action } from 'actions'

const { handler, initial } = generateHandlerArgs(action, 'recoAccount')

export const adminRecoAccount = handleActions(handler, initial)
